import styled from "styled-components";

import { carbon } from "app/components/React/read-only-input/ReadOnlyInput";
export const VisitsShareContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: end;
`;

export const VisitsValue = styled.span`
    color: ${carbon[500]};
    min-width: 50px;
    display: flex;
    justify-content: end;
`;

export const ShareValue = styled.span`
    color: ${carbon[300]};
    min-width: 50px;
    display: flex;
    justify-content: end;
`;
